import { Box, Dropdown, DropdownItem } from '@amzn/ring-ui-react-components';

export interface Location {
  name: string;
  id: string;
}

export interface LocationSelectorDropdownProps {
  locations: Array<Location>;
  onClick: (args: string) => void;
  selectedLocation: string;
}

export const LocationSelectorDropdown = ({
  locations,
  selectedLocation,
  onClick,
}: LocationSelectorDropdownProps) => {
  if (locations.length < 2) return null;

  return (
    <Box mb={6}>
      <Dropdown value={selectedLocation} width="100%">
        {locations?.map((location) => (
          <DropdownItem
            key={location.id}
            isSelected={selectedLocation === location.id}
            value={location.id}
            onClick={() => onClick(location.id)}
          >
            {location.name}
          </DropdownItem>
        ))}
      </Dropdown>
    </Box>
  );
};
